export default __webpack_public_path__ + "static/media/widget_watchbox_vpmspx60_buy.d03bdbb2.mp3";